import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { styled, withTheme } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import { ProfileManager } from '@kailona/core';
import HeaderTab from './HeaderTab';
import { Box, IconButton } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { withModal } from '../../context/ModalContext';
import { withMain } from '../../context/MainContext';
var StyledTabs = styled(withTheme(Tabs))(function (props) {
  return {
    backgroundColor: props.theme.palette.whiteSmoke.main,
    padding: '0 15px',
    height: '40px !important',
    '& .MuiTabs-flexContainer': {
      alignItems: 'flex-end'
    }
  };
});

var ProfileHeader = /*#__PURE__*/function (_Component) {
  _inherits(ProfileHeader, _Component);

  var _super = _createSuper(ProfileHeader);

  function ProfileHeader(props) {
    var _this;

    _classCallCheck(this, ProfileHeader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getUsers", function () {
      return ProfileManager.profiles.map(function (profile) {
        return {
          id: profile.patientId,
          name: profile.patientFullName,
          active: profile.patientId === ProfileManager.activePatientId
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (newValue) {
      ProfileManager.activePatientId = newValue;

      _this.props.setUserId(newValue);

      _this.setState({
        selectedTab: newValue
      });

      _this.props.history.push('/');
    });

    _defineProperty(_assertThisInitialized(_this), "refreshUsers", function () {
      var users = _this.getUsers();

      _this.setState({
        users: users,
        selectedTab: ProfileManager.activePatientId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleNewClick", function () {
      _this.props.toggleProfileEditModal(true, {
        onUpdate: _this.refreshUsers
      });
    });

    var _users = _this.getUsers();

    _this.state = {
      users: _users,
      selectedTab: ProfileManager.activePatientId || 0
    };

    _this.props.setUserId(ProfileManager.activePatientId);

    return _this;
  }

  _createClass(ProfileHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.firstTime) {
        // Show profile update modal to let user update patient information first time
        this.props.toggleProfileEditModal(true, {
          profile: ProfileManager.activeProfile,
          firstTime: true,
          onUpdate: this.refreshUsers
        });
        this.props.setUserId(ProfileManager.activeProfile);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var selectedTab = this.state.selectedTab;
      return /*#__PURE__*/React.createElement(StyledTabs, {
        value: selectedTab,
        "aria-label": "profile tabs",
        TabIndicatorProps: {
          style: {
            background: 'none'
          }
        }
      }, this.state.users.map(function (user, index) {
        return /*#__PURE__*/React.createElement(HeaderTab, {
          key: index,
          label: user.name,
          id: user.id,
          value: user.id,
          handleClick: _this2.handleClick,
          active: selectedTab === user.id,
          refreshUsers: _this2.refreshUsers
        });
      }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(IconButton, {
        onClick: this.handleNewClick
      }, /*#__PURE__*/React.createElement(AddIcon, null))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ProfileHeader;
}(Component);

var _default = withRouter(withMain(withModal(ProfileHeader)));

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledTabs, "StyledTabs", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/ProfileHeader.js");
  reactHotLoader.register(ProfileHeader, "ProfileHeader", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/ProfileHeader.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/ProfileHeader.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();